import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router'
import { AuthLayout } from 'shared/layout'
import { uiStore } from 'shared/store/uiStore'
import { useReCaptchaContext } from 'entities/Auth'
import { SuccessForm } from 'pages/auth/pages/forgot/ui/ForgotPassword/ui/SuccessFrom/SuccessForm'
import { ForgotPasswordStore } from 'pages/auth/pages/forgot/ui/ForgotPassword/store/forgotPasswordStore'
import { ForgotPasswordForm } from 'pages/auth/pages/forgot/ui/ForgotPassword/ui/ForgotPasswordForm/ForgotPasswordForm'
import styles from './styles.module.scss'

export const ForgotPasswordContent = observer(({ store }: { store: ForgotPasswordStore }) => {
  if (store.success) {
    return <SuccessForm store={store} />
  }

  return (
    <div className={styles.wrap}>
      <AuthLayout
        title={'Forgot your password?'}
        subtitle={
          <div className={styles.subtitle}>
            {
              "Enter your e-mail address and we'll send you instructions on how to reset your password."
            }
          </div>
        }
        form={<ForgotPasswordForm store={store} />}
      />
    </div>
  )
})

export const ForgotPassword = observer(() => {
  const storeReCaptchaContext = useReCaptchaContext()
  const location = useLocation()
  const initialEmail: string | undefined = location.state?.email
  const [store] = useState(() => new ForgotPasswordStore(storeReCaptchaContext, initialEmail))

  useEffect(() => {
    if (initialEmail) {
      uiStore.changeRoute({
        path: location.pathname,
        method: 'replace',
        options: { state: { ...location.state, email: undefined } },
      })
    }
  }, [])

  return <ForgotPasswordContent store={store} />
})

export default ForgotPassword
